<template>
  <div>
    <div class="container">
      <div class="slider to-index">
        <div class="slide" v-for="(item, index) in videoData" :key="item.id">
          <video
            muted
            autoplay
            loop
            :class="{ active: index === count }"
            @timeupdate="handleProgress(index, $event)"
          >
            <source :src="item.pcUrl" type="video/mp4" />
            <strong>Your browser does not support the video tag.</strong>
          </video>
          <div class="slide-desc">
            <h2>
              {{ item.title }}
            </h2>
            <p>{{ item.subtitle }}</p>
          </div>
        </div>

        <div class="arrow-wrap">
          <button class="arrow-left" @click="showPreviousItem()">
            <img src="https://img.davich.com/image/main/btn-caret-left.png" alt="" />
            <span class="en-font">Prev</span>
          </button>
          <button class="arrow-right" @click="showNextItem()">
            <img src="https://img.davich.com/image/main/btn-caret-right.png" alt="" />
            <span class="en-font">Next</span>
          </button>
        </div>
        <div class="video-control">
          <div class="progress-wrap en-font">
            <!-- 영상 개수만큼만 버튼 생성 -->
            <div class="progress-bar" v-for="(item, index) in videoData" :key="item.id">
              <p @click="selectVideo(index)" class="select-video-btn">{{ String(index + 1).padStart(2, "0") }}</p>
              <div class="progress" :style="{ display: index === count ? 'flex' : 'none' }">
                <div class="progress__filled" :style="{ flexBasis: `${percent}%` }"></div>
              </div>
            </div>
          </div>
          <div class="slider-ctrl-btn-box">
            <button class="slider-ctrl-btn__play sm" :class="{ on: paused }" @click="playVideo()">
              <img src="https://img.davich.com/image/main/btn-play.png" alt="play button" />
            </button>
            <button class="slider-ctrl-btn__pause sm" :class="{ on: !paused }" @click="pauseVideo()">
              <img src="https://img.davich.com/image/main/btn-stop.png" alt="play button" />
            </button>
          </div>
        </div>
        <div class="scroll-mouse">
          <img src="https://img.davich.com/image/main/icon-scroll.png" alt="스크롤" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  beforeCreate() {
    this.$store.dispatch("FETCH_MAIN_VIDEO");
  },

  data() {
    return {
      count: 0,
      percent: 0,
      paused: false,
    };
  },

  computed: {
    ...mapState({
      videoData: (state) => state.videoData,
    }),
  },

  watch: {
    //영상 데이터가 들어오면 실제 개수 범위 안에서 랜덤 시작
    videoData: {
      immediate: true,
      handler(list) {
        this.count = list.length ? Math.floor(Math.random() * list.length) : 0;
        this.percent = 0;
      },
    },
  },

  methods: {
    handleProgress(index, event) {
      if (index !== this.count) return;
      const video = event.target;
      this.percent = video.duration ? (video.currentTime / video.duration) * 100 : 0;
    },

    showNextItem() {
      const itemCount = this.videoData.length;
      if (!itemCount) return;
      this.selectVideo((this.count + 1) % itemCount);
    },

    showPreviousItem() {
      const itemCount = this.videoData.length;
      if (!itemCount) return;
      this.selectVideo((this.count - 1 + itemCount) % itemCount);
    },

    //숫자클릭하여 비디오변경
    selectVideo(index) {
      this.count = index;
      this.percent = 0;
      //이전 영상에서 일시정지했더라도 새로 보이는 영상은 재생
      this.$nextTick(() => {
        const video = this.activeVideo();
        if (video && video.paused) video.play().catch(() => {});
        this.paused = false;
      });
    },

    activeVideo() {
      return this.$el.querySelectorAll("video")[this.count];
    },

    pauseVideo() {
      const video = this.activeVideo();
      if (!video) return;
      video.pause();
      this.paused = true;
    },
    playVideo() {
      const video = this.activeVideo();
      if (!video) return;
      video.play();
      this.paused = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";

.container {
  position: relative;
  height: 100vh;
  min-width: 1720px;
  min-width: 1400px;
  overflow: hidden;
  color: white;
  .slider {
    .slide {
      &:after {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: $color-black;
        opacity: 0.05;
        z-index: 0;
      }
      video {
        width: 100%;
        height: 100vh;
        object-fit: cover;
        display: none;
        margin: auto;

        &.active {
          display: block;
          animation: fadeImg 0.8s;
        }
      }
      video.active + .slide-desc {
        display: block;
      }
      .slide-desc {
        display: none;
        position: absolute;
        width: 1400px;
        z-index: 2;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        h2 {
          font-size: 70px;
          margin-bottom: 7px;
          font-weight: 700;
          line-height: 103px;
          letter-spacing: -2.1px;
          span {
            color: $color-skyblue;
          }
        }
        p {
          font-size: 25px;
          opacity: 0.8;
          font-weight: 300;
          line-height: 37px;
          margin-left: 4px;
        }
      }
    }
    .arrow-wrap {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 1820px;
      height: auto;
      display: flex;
      justify-content: space-between;
      z-index: 2;
      .arrow-left,
      .arrow-right {
        display: flex;
        color: $color-white;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        font-weight: 300;
        img {
          margin-bottom: 10px;
        }
      }
    }
    .video-control {
      position: absolute;
      width: 1400px;
      left: calc(50% + 7px);
      transform: translate(-50%, -50%);
      top: 70%;
      display: flex;
      .slider-ctrl-btn-box {
        .checked {
          opacity: 0.3;
        }
      }
      .progress-wrap {
        font-size: 14px;
        font-weight: 600;
        display: flex;
        .progress-bar {
          display: flex;
          align-items: center;
          margin-right: 30px;
          p {
            margin-right: 10px;
          }
          .progress {
            width: 60px;
            height: 2px;
            display: flex;
            background: rgba(255, 255, 255, 0.5);
            display: none;
            .progress__filled {
              background-color: $color-white;
            }
          }
        }
      }
      .slider-ctrl-btn-box {
        button {
          padding: 0;
          padding-right: 20px;
          &.on {
            opacity: 0.4;
          }
        }
      }
    }
  }
}
//화면전환 시 효과
@keyframes fadeImg {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.select-video-btn {
  cursor: pointer;
}
// [class^="slider-ctrl-btn__"] {
//   display: inline-block;
//   margin: 0 0.5rem;
//   background-repeat: no-repeat;
//   background-position: center;
//   background-color: transparent !important;
//   background-size: 100%;
//   opacity: 0.4;
//   cursor: pointer;
// }
// [class^="slider-ctrl-btn__"].sm {
//   width: 10px;
//   height: 8px;
// }
</style>
